import CryptoJS from 'crypto-js';

/**
 * @param {string} prefix
 * @param {string} value
 * @returns {string}
 */
export const prefix = (prefix, value, separate = "") => {
  if (separate.length > 0) {
    return prefix + separate + value;
  } else {
    return prefix + ucfirst(value);
  }
};

/**
 * @param {string} prefix
 * @param {string} value
 * @returns {string}
 */
export const unprefix = (prefix, value, separate = "") => {
  let v = lcfirst(value.replace(prefix, ""));
  if (!separate) {
    return v;
  }
  return v.replace(separate, "");
};

/**
 * @param {string} str
 */
export const ucfirst = (str) => {
  if (typeof str !== "string") {
    str = String(str);
  }
  str = str.trim();
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * @param {string} str
 */
export const lcfirst = (str) => {
  str = String(str);
  return str.charAt(0).toLowerCase() + str.slice(1);
};

/**
 *
 * @param {string} str
 * @param {string} c char
 */
export const ltrim = (str, c) => {
  if (typeof c === "undefined") {
    c = "\\s";
  }
  return str.replace(new RegExp("^[" + c + "]*", ""), "");
};

/**
 *
 * @param {string} str
 * @param {string} c char
 */
export const rtrim = (str, c) => {
  if (typeof c === "undefined") {
    c = "\\s";
  }
  return str.replace(new RegExp("[" + c + "]*$"), "");
};

export const trim = (str, c) => {
  return rtrim(ltrim(str, c), c);
};

export const format = (format, ...args) => {
  return format.replace(/{(\d+)}/g, function(match, number) {
    return typeof args[number] !== "undefined" ? args[number] : match;
  });
};

export const encrypt = (str, key = 'Gd2dH9qc4UHv') => {
  let encJson = CryptoJS.AES.encrypt(JSON.stringify(str), key).toString()
  let encData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson))
  return encData;
};

export const decrypt = (ciphertext, key = 'Gd2dH9qc4UHv') => {
  let decData = CryptoJS.enc.Base64.parse(ciphertext).toString(CryptoJS.enc.Utf8)
  let bytes = CryptoJS.AES.decrypt(decData, key).toString(CryptoJS.enc.Utf8)
  return JSON.parse(bytes);
}

export default {
  rtrim,
  ltrim,
  trim,
  lcfirst,
  ucfirst,
  prefix,
  unprefix,
  format,
  encrypt,
  decrypt
};
